import {api,imgPath} from '../../../common/config.js';
import {store} from '../../../store/store.js';
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import search from '../../../components/search.vue';
export default{
  name: 'introduce',
  data(){
    return {
      imgPath:imgPath,
      fromSearch:0,
      libCode: '',
      libId: 0,
      libraryInfoData:{
        info:{
          libCode:'',
          address:'',
        }
      },
      libraryBuniessData: {},
      lightTime: {},
      libLevel:'',
      error: store.imgError_library,
      webType: store.webType,
      opacType:store.opacType,
      weeks:[
          {days:'周一',openTime:''},
          {days:'周二',openTime:''},
          {days:'周三',openTime:''},
          {days:'周四',openTime:''},
          {days:'周五',openTime:''},
          {days:'周六',openTime:''},
          {days:'周日',openTime:''}
      ],
      otherProvisions:'',
      today:'',
      closed:'闭馆',
      libraryIntroduce: '',
      librarybookData:{},
      timer:'',//定时器
    }
  },
  components:{
    search
},
  beforeMount() {
    if(store.webType == 0) {
      store.wrap.activeRouteName = '图书馆';
      store.libraryNav.activeNav = '本馆介绍';
    } else {
      store.wrap.activeRouteName = '本馆介绍';
    }
    this.libId = this.$route.query.libId || store.library.id || 0;
    this.fromSearch = this.$route.query.fromSearch || 0;
    this.libCode = this.$route.query.libCode || this.$route.query.hallCode || store.library.libCode||'';
    this.latLng = this.$route.query.latLng || store.localtionArea.latLng || '';
    this.libLevel=this.$route.query.libLevel || store.library.libraryLevel || '';
    this.queryInfo();
  },
  mounted(){
    if(this.libCode == 'AAANA'|| this.libCode == 'AAANA'){
      this.timer = setInterval(this.getLibraryInfoData,5000);
    }else{
      this.getLibraryInfoData()
    }
  },
  beforeDestroy(){
    clearInterval(this.timer)
  },
  watch:{
      $route() {
          this.queryInfo()
      }
  },
  methods: {
    queryInfo:function () {
        //获取图书馆详情
        /**
         * flag:用于存放搜索记录 1:图书馆 2书店
         * */
        var url = api.library.info.replace('{fromSearch}', this.fromSearch).replace('{flag}',1).replace('{libId}', this.libId).replace('{lngLat}', this.latLng);
        ajaxUtil.ajaxJson(url, null, "GET", (data) => {
            this.libraryInfoData = data;
            if (this.libraryInfoData.htmlInfo.content){
                this.libraryIntroduce = this.libraryInfoData.htmlInfo.content.replace(/(\r\n|\n|\r)/gm,'<br/>').replace(/( )/gm,'&nbsp;')
            }
        }, null, this);

        //获取图书馆开放时间设置
        this.getOPenTime();

        //获取【其他规定】字段
        var path = api.library.otherProvisions.replace('{libCode}', this.libCode);
        ajaxUtil.ajaxJson(path, null, "GET", (data) => {
            this.otherProvisions = data.regulation;
        }, null, this);
    },

      //获取图书馆开放时间设置

      getOPenTime(){
          var url = api.library.libLight.replace('{libCode}', this.libCode);
          ajaxUtil.ajaxJson(url, null, "GET", (data) => {
              this.libraryBuniessData = data.lightTimeNew;
              this.today = this.libraryBuniessData.today;
              this.weeks[0].openTime = this.libraryBuniessData.week.monday;
              this.weeks[1].openTime = this.libraryBuniessData.week.tuesday;
              this.weeks[2].openTime = this.libraryBuniessData.week.wednesday;
              this.weeks[3].openTime = this.libraryBuniessData.week.thursday;
              this.weeks[4].openTime = this.libraryBuniessData.week.friday;
              this.weeks[5].openTime = this.libraryBuniessData.week.saturday;
              this.weeks[6].openTime = this.libraryBuniessData.week.sunday;
          }, null, this);
      },
      getLibraryInfoData(){
        let url = api.library.infoData.replace('{libCode}', this.libCode);
        ajaxUtil.ajaxJson(url, null, "GET", (data) => {
          this.librarybookData= data;
        }, null, this);
      },
    openMap() {
      window.open(`/map.html?location=${this.libraryInfoData.info.lngLat}`)
    }
  }
}
